import { FetchAPI } from 'utils/fetch/fetch-api';
import { PixDTO } from 'utils/types/pix';
import { RequestQuery } from 'utils/types/request-types';

class PixService extends FetchAPI {
	getPix = (query: RequestQuery): Promise<PixDTO> => this.get<PixDTO>(query);
}

export { PixService };
